import { useEffect, useState } from 'react'
import { api } from '../../modules/api'

/**
 *
 * @param {String} url : api url
 * @param {'GET' | 'POST' | 'DELETE'} post: api method type
 * @param {Object} reqPayload: request payload
 * @param {Any} initialState: initial response data type
 * @returns
 */
const useFetch = (url, post, reqPayload, { initialState, predicate }) => {
    const [loading, setLoading] = useState(false)
    const [response, setResponse] = useState(initialState)
    const [error, setError] = useState({})

    const fetch = async () => {
        try {
            setLoading(true)
            const { data } = await api(url, post, reqPayload)
            setResponse(data)
            setLoading(false)
        } catch (error) {
            setError(error)
            setLoading(false)
            setResponse(initialState)
        }
    }

    useEffect(() => {
        if ((!!predicate && predicate()) || !predicate) {
            fetch()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return { loading, response, error }
}

export { useFetch }
